import axios from 'axios';
import store from '../store';

const apiUrl = process.env.VUE_APP_BASE_URL;

  const instance = axios.create({
    baseURL: apiUrl,
  })

  instance.interceptors.request.use( (config) => {
    const { token } = store.state.authentication;
    if (token) {
        config.headers.Authorization =  `${token}`;
        if (config.url === process.env.VUE_APP_URI + 'images') {
            config.headers['Content-Type'] = 'multipart/form-data';
        }
    }
    return config;
}, (err) => {
    return Promise.reject(err);
});

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401 && store.state.authentication.authenticated) {
        store.dispatch('authentication/logout').then(() => {
          import('../router').then(({ default: router }) => {
            if (router.currentRoute.value.name !== 'login') {
              router.push({ name: 'login' });
            }
          });
        });
      }
      return Promise.reject(error);
    }
  );

export default instance;